<template>
  <div class="search-bar">
    <el-input
      v-model="keyword"
      :placeholder="$t('view.search.placeholder')"
      prefix-icon="el-icon-search"
      size="medium"
      clearable
      @keyup.enter.native="doSearch"
      @input="handleSuggest"
    />
    <div v-if="suggestions.length > 0 && keyword" class="search-suggestions">
      <div
        v-for="item in suggestions"
        :key="item.id"
        class="suggest-item"
        @click="selectItem(item)"
      >
        <span class="suggest-name">{{ item.name }}</span>
        <span class="suggest-cat">{{ item.categoryName }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { searchTools } from '@/api/site'

export default {
  data() {
    return {
      keyword: '',
      suggestions: []
    }
  },
  methods: {
    handleSuggest() {
      if (!this.keyword) {
        this.suggestions = []
        return
      }
      searchTools({ name: this.keyword, pageNum: 1, pageSize: 8 }).then(res => {
        this.suggestions = res.data || []
      })
    },
    doSearch() {
      if (this.keyword.trim()) {
        this.$router.push(`/search?q=${encodeURIComponent(this.keyword)}`)
        this.suggestions = []
      }
    },
    selectItem(item) {
      this.keyword = ''
      this.suggestions = []
      this.$emit('select', item.slug)
    }
  }
}
</script>

<style scoped>
.search-bar {
  position: relative;
  width: 100%;
  max-width: 480px;
}
.search-suggestions {
  position: absolute;
  top: 42px;
  left: 0;
  right: 0;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  z-index: 200;
  max-height: 320px;
  overflow-y: auto;
}
.suggest-item {
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  transition: background 0.15s;
}
.suggest-item:hover { background: #f0f2f5; }
.suggest-name { font-size: 14px; color: #303133; }
.suggest-cat { font-size: 12px; color: #909399; }
</style>
